
const initTextCleaner = () => {
    Alpine.data('textCleaner', () => ({
        inputText: '',
        outputText: '',
        copied: false,
        options: {
            extraSpaces: true,
            emptyLines: true,
            lineBreaks: false,
            tabs: true,
            case: 'none',
            html: false,
            urls: false,
            emails: false,
            numbers: false,
            punctuation: false,
            prefix: '',
            suffix: ''
        },
        inputStats: { words: 0 },
        outputStats: { words: 0 },

        init() {
            this.$watch('inputText', () => this.updateStats());
        },
        updateStats() {
            this.inputStats.words = this.inputText.trim() ? this.inputText.trim().split(/\s+/).length : 0;
            if (this.outputText) {
                this.outputStats.words = this.outputText.trim() ? this.outputText.trim().split(/\s+/).length : 0;
            }
        },
        clean() {
            let text = this.inputText;
            if (this.options.html) text = text.replace(/<[^>]*>/g, '');
            if (this.options.urls) text = text.replace(/(?:https?|ftp):\/\/[\n\S]+/g, '');
            if (this.options.emails) text = text.replace(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi, '');
            if (this.options.numbers) text = text.replace(/[0-9]/g, '');
            if (this.options.punctuation) text = text.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, '');
            
            if (this.options.tabs) text = text.replace(/\t/g, ' ');
            if (this.options.extraSpaces) text = text.replace(/[ ]{2,}/g, ' ');
            
            if (this.options.case === 'upper') text = text.toUpperCase();
            else if (this.options.case === 'lower') text = text.toLowerCase();
            else if (this.options.case === 'title') text = text.toLowerCase().replace(/(?:^|\s)\w/g, function(a) { return a.toUpperCase(); });
            else if (this.options.case === 'sentence') text = text.toLowerCase().replace(/(^\s*\w|[\.\!\?]\s*\w)/g, function(c) { return c.toUpperCase() });
            
            let lines = text.split('\n');
            if (this.options.emptyLines) lines = lines.filter(line => line.trim() !== '');
            if (this.options.prefix) lines = lines.map(line => this.options.prefix + line);
            if (this.options.suffix) lines = lines.map(line => line + this.options.suffix);
            
            text = lines.join('\n');
            if (this.options.lineBreaks) text = text.replace(/\n/g, ' ');

            this.outputText = text;
            this.updateStats();
        },
        clearInput() {
            this.inputText = '';
            this.outputText = '';
            this.updateStats();
        },
        copyOutput() {
            if (!this.outputText) return;
            navigator.clipboard.writeText(this.outputText);
            this.copied = true;
            setTimeout(() => this.copied = false, 2000);
        },
        applyPreset(type) {
            // Reset options first
            this.resetOptions();
            
            if (type === 'removeSpaces') {
                this.options.extraSpaces = true;
                this.options.tabs = true;
            } else if (type === 'removeLines') {
                this.options.emptyLines = true;
            } else if (type === 'oneLine') {
                this.options.lineBreaks = true;
                this.options.extraSpaces = true;
                this.options.emptyLines = true;
            }
            this.clean();
        },
        resetOptions() {
             this.options = {
                extraSpaces: false,
                emptyLines: false,
                lineBreaks: false,
                tabs: false,
                case: 'none',
                html: false,
                urls: false,
                emails: false,
                numbers: false,
                punctuation: false,
                prefix: '',
                suffix: ''
            };
        }
    }));
};

if (typeof window.Alpine !== 'undefined') {
    initTextCleaner();
} else {
    document.addEventListener('alpine:init', initTextCleaner);
}
